/**
 * Shared DataTestId prop type and normalization utility.
 *
 * Components accept both `data-testId` (camelCase, used in codebase)
 * and `data-testid` (lowercase, HTML standard). This utility normalizes
 * them to the standard `data-testid` attribute.
 */
export type DataTestIdProps = {
  "data-testId"?: string;
  "data-testid"?: string;
};

export function extractTestId(props: DataTestIdProps): string | undefined {
  return props["data-testId"] ?? props["data-testid"];
}
